import React from "react";
import { Button } from "primereact/button";

export default function NewTabDemo() {
  return (
    <div className="mx-4">
      <div className="card shadow-md rounded-lg p-4 mt-3">
        <h2 className="text-2xl font-bold mb-3">Demo: New Tab</h2>
        <p className="mb-4">Yeh ek demo tab hai. Aap yahan se kisi bhi demo feature ka preview rakh sakte hain.</p>
        <div className="flex gap-3">
          <Button
            label="Show Sample Section"
            onClick={() => alert("Sample section would be inserted into the frontend.")}
            className="p-primary-btn"
          />
          <Button
            label="Open Sections Builder"
            onClick={() => window.location.assign("/site-setup/menu")}
            className="p-secondary-btn"
          />
        </div>
      </div>
    </div>
  );
}
